import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import {Grid} from "@mui/material";

// Components
import BottomDrawer from "components/WMS/Mobile/BottomDrawer";
import MobileItem from "components/WMS/Mobile/MobileItem";
import ThumbnailAndNotification from "components/WMS/Mobile/ThumbnailAndNotification";
import VariationCount from "components/WMS/Mobile/WmsItemList/components/VariationCount";
import LineItemOptionList from "components/WMS/Mobile/WmsItemList/components/LineItemOptionList";
import WmsItemCodes from "components/WMS/Mobile/WmsItemList/components/WmsItemCodes";
import WmsItemPlaceList from "components/WMS/Mobile/WmsItemList/components/WmsItemPlaceList";
import WmsItemInformationDrawer from "components/WMS/Mobile/WmsItemList/components/WmsItemInformationDrawer";
import RetailerNameDrawerTitle from "components/WMS/Mobile/WmsItemList/components/RetailerNameDrawerTitle";

// Utils
import {WmsItemsStatus} from "utils/WmsItemsStatus";

// Contexts
import {WMSContext} from "views/wms/context/WMSContext";

RetailerProducts.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    wmsItems: PropTypes.array.isRequired,
};

function RetailerProducts({open, handleClose, wmsItems = []}) {
    const [selectedWmsItem, setSelectedWmsItem] = React.useState(null);

    const { groupWmsItemsBySku } = React.useContext(WMSContext);

    return (
        <BottomDrawer
            title={<RetailerNameDrawerTitle wmsItems={wmsItems}/>}
            open={open}
            onClose={handleClose}
            disablePortal={true}
            openMaxHeight
            noHeightLimit
        >
            {groupWmsItemsBySku(wmsItems).map((item, index) => (
                <MobileItem onClick={() => setSelectedWmsItem(item)} key={index}>
                    <MobileItem.LeftSide
                        title={item.lineItem.name}
                        subtitle={<LineItemOptionList options={item.lineItem?.options} />}
                        underTitle={
                            <Grid container>
                                <WmsItemCodes wmsItem={item} />
                                <WmsItemPlaceList wmsItem={item} />
                            </Grid>
                        }
                    >
                        <ThumbnailAndNotification
                            link={item.lineItem.pictures?.[0]}
                            alt={item.lineItem.name}
                            validated={item.status === WmsItemsStatus.IN_TROLLEY}
                        />
                    </MobileItem.LeftSide>
                    <MobileItem.RightSide>
                        <VariationCount count={item?.count} />
                    </MobileItem.RightSide>
                </MobileItem>
            ))}
            <WmsItemInformationDrawer
                selectedWmsItem={selectedWmsItem}
                handleClose={() => setSelectedWmsItem(null)}
            />
        </BottomDrawer>
    );
}

export default RetailerProducts;
